export default __webpack_public_path__ + "static/11-settings-55eb437be9cd3928ffffc23560bdd8bb.png";